import React from 'react';
import ContainerStyled from './ContainerStyles';

export default function Container({ className, children }) {
    return <ContainerStyled className={className}>{children}</ContainerStyled>;
}
